import { css } from '@emotion/core';
export var callButton = {
  name: "laxdbq",
  styles: "flex:1;font-weight:normal;padding:0 20px;"
};